<div class="lvi-content">
    <div class="avatar">
        <span [translate]="'admin.bibliotheque.geographie.departements.avatar'"></span>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="goToDetailDepartement()">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.pays">
                <strong [translate]="'geographie.pays'"></strong>
                <span *ngIf="data.pays.code2" class="flag-icon me-1" [ngClass]="'flag-icon-'+ data.pays.code2.toLowerCase()"></span>
                <span>{{ data.pays.libelle }}</span>
            </li>
            <li *ngIf="data.regionAdmin.libelle">
                <strong [translate]="'geographie.region'"></strong>
                <span>{{ data.regionAdmin.libelle }}</span>
            </li>
            <li *ngIf="data.code">
                <strong [translate]="'admin.bibliotheque.geographie.territoire.code'"></strong>
                <span>{{ data.code }}</span>
            </li>
        </ul>
    </div>
</div>